<template>
  <div>
    <span class="link-small--dark-60 text-gray-60 flex items-center">
      {{ bp('alabamaCheckoutTitle1') }}
      <i class="md-14 ml-25 cursor-pointer" @click="showInfoDialog">info_outline</i>
    </span>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="bp('alabamaCheckoutTitle2')"
      :center="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      :z-index="16000011"
      :close-dialog-tooltip="bp('closeDialogToolTip')"
    >
      <p class="mb-2">{{ bp('alabamaCheckoutBody1') }}</p>
      <p>{{ bp('alabamaCheckoutBody2') }}</p>
    </el-dialog>
  </div>
</template>
<script>
import ElDialog from '../Dialog';

export default {
  name: 'SsutInfoIcon',
  components: {ElDialog},
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    showInfoDialog() {
      this.dialogVisible = true;
    },
  },
};
</script>
